module.exports = __webpack_public_path__ + "media/images/watermark-3e4fad638e4b4de7dadf9d5100e02743.png";